import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class UnitModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (UnitModel._instance == null) UnitModel._instance = new UnitModel(authManager);
        return UnitModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'measurements/units', 'measurements/units/codelist');

        this.entityName = 'measurements.Unit';
        this.privileges = {
            create: [["#admin"]],
            read: [["#admin"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Measurement Unit';
        this.setLabel = 'Measurement Units';

        this.browser = {
            name: 'default-measurements-unit-browser',
            moduleName: 'default-measurements-unit-browser',
            moduleTitle: 'Measurement Units',
            moduleStateSlotName: 'default-measurements-unit-browser',
        };

        this.editor = {
            name: 'default-measurements-unit-editor',
            moduleName: 'default-measurements-unit-editor',
            moduleTitle: 'Measurement Unit',
            moduleStateSlotName: 'default-measurements-unit-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'symbol',
                type: 'string',
                persistent: true,
                label: 'Symbol',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displaySymbol',
                type: 'string',
                persistent: true,
                label: 'Display Symbol',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitGroupId',
                type: 'int',
                persistent: true,
            },
            {
                name: 'quantityId',
                type: 'Quantity',
                persistent: true,
                inEditor: true,
                filterable: true,
            },
            {
                name: 'baseUnitId',
                type: 'Unit',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'baseFactor',
                type: 'float',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'baseOffset',
                type: 'float',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'format',
                type: 'string',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'hint',
                type: 'text',
                persistent: true,
            },
            {
                name: 'info',
                type: 'text',
                persistent: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
